import { Directive, ElementRef, HostListener, Input } from '@angular/core';


@Directive({
  selector: '[autoresize]'
})
export class AutoresizeDirective {

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.adjust(this.el.nativeElement);
  }
  
  @HostListener('input', ['$event.target'])
  @HostListener('scroll', ['$event.target'])
  onInput(textArea: HTMLTextAreaElement): void {
    this.adjust(textArea);
  }
  @HostListener('blur', ['$event.target'])
  onBlur(textArea: HTMLTextAreaElement): void {
    this.adjust(textArea);
  }

  private adjust(textArea: HTMLTextAreaElement): void {
    const minRows = textArea.getAttribute('rows');
    textArea.style.height = 'auto';
    textArea.style.height = textArea.scrollHeight + 'px';
    if (minRows && textArea.rows < parseInt(minRows)) {
      textArea.rows = parseInt(minRows);
    }
  }
}
